import { useEffect } from "react";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";

function Rtc() {
    useEffect(() => {
        const popup = window.open(
            "https://rtc.bluept.cloud",
            "RTCWindow",
            "width=800,height=600,resizable=yes,scrollbars=yes"
        );

        if (!popup) {
            alert("Popup blocked! Please allow popups for this site.");
        }
    }, []);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh" }}>
                <p>RTC has been opened in a popup. If not, please allow popups.</p>
            </div>
            <iframe src="https://rtc.bluept.cloud/lanes" title="RTC" style={{ width: "100%", height: "100%" }} />
        </DashboardLayout>
    );
}

export default Rtc;
